import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
import drawerReducer from './slice/drawerSlice'
import currentUserReducer from './slice/currentUserSlice'
import {auth} from './api/service/auth'
import {passwordRecovery} from './api/service/passwordRecovery'
import messageReducer from './slice/messageSlice'
import {rtkQueryErrorLogger} from "./middleware/rtkQueryErrorLogger";
import {current} from "./api/service/current";
import {demo} from  './api/service/demo'
import {ecommerce} from "./api/service/ecommerce";
export const store = configureStore({
    reducer: {
        //Apis
        [auth.reducerPath]: auth.reducer,
        [passwordRecovery.reducerPath]: passwordRecovery.reducer,
        [current.reducerPath]: current.reducer,
        [demo.reducerPath]: demo.reducer,
        [ecommerce.reducerPath]: ecommerce.reducer,
        //slice
        drawer: drawerReducer,
        message: messageReducer,
        currentUser: currentUserReducer,


    },

    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat(auth.middleware)
        .concat(passwordRecovery.middleware)
        .concat(current.middleware)
        .concat(demo.middleware)
        .concat(ecommerce.middleware)
        .concat(rtkQueryErrorLogger)
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

setupListeners(store.dispatch)
